import {
  collection,
  doc,
  getDoc,
  getDocs,
  onSnapshot,
  query,
  where,
} from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { db } from "../../../firebase";

const DashBoardViewModal = () => {
  const [TotalNoOFStudents, setTotalNoOFStudents] = useState(0);
  const [TotalNoOFTeachers, setTotalNoOFTeachers] = useState(0);
  const [TotalNoOFClasses, setTotalNoOFClasses] = useState(0);

  const [ChartData, setChartData] = useState({
    options: {
      chart: {
        id: "basic-line",

        toolbar: {
          tools: {
            selection: false,
            zoom: false,
            zoomin: false,
            zoomout: false,
            pan: false,
            reset: false,
          },
        },
      },

      xaxis: {
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
      },
      colors: ["#3d5ee1", "#70c4cf"],
    },
    series: [
      {
        name: "Teachers",
        data: [30, 40, 35, 50, 49, 60, 70, 91, 125, 100, 85, 90],
      },
      {
        name: "Students",
        data: [15, 25, 20, 35, 34, 45, 55, 76, 100, 75, 60, 65],
      },
    ],
  });

  const [VerticalChart, setVerticalChart] = useState({
    series: [
      {
        name: "Girls",
        data: [44, 55, 57, 56, 61, 58, 63, 60, 66],
      },
      {
        name: "Boys",
        data: [76, 85, 101, 98, 87, 105, 91, 114, 94],
      },
    ],

    options: {
      colors: ["#3d5ee1", "#70c4cf"],
      chart: {
        type: "bar",
        height: 350,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          endingShape: "rounded",
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
      },
      xaxis: {
        categories: [
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
        ],
      },
      yaxis: {
        title: {
          text: "(Students)",
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return "Total" + val + " Students";
          },
        },
      },
    },
  });

  let schoolId = localStorage.getItem("schoolId");
  schoolId = JSON.parse(schoolId);

  //   Find the total number of students
  useEffect(() => {
    if (schoolId) {
      const usersRef = collection(db, "Users");
      const studentsQuery = query(
        usersRef,
        where("UserType", "==", "student"),
        where("SchoolID", "==", schoolId)
      );
      const unsubscribe = onSnapshot(studentsQuery, (snapshot) => {
        const numStudents = snapshot.size;
        setTotalNoOFStudents(numStudents);
      });
      const TeachersQuery = query(
        usersRef,
        where("UserType", "==", "teacher"),
        where("SchoolID", "==", schoolId)
      );
      const TeacherUnsubscribe = onSnapshot(TeachersQuery, (snapshot) => {
        const numTeachers = snapshot.size;
        setTotalNoOFTeachers(numTeachers);
      });
      const ClassesRef = collection(db, "Classes");
      const ClassesQuery = query(ClassesRef, where("SchoolID", "==", schoolId));
      const ClassesUnsubscribe = onSnapshot(ClassesQuery, (snapshot) => {
        const numClasses = snapshot.size;
        setTotalNoOFClasses(numClasses);
      });
      return () => {
        unsubscribe();
        TeacherUnsubscribe();
        ClassesUnsubscribe();
      };
    }
  }, []);

  useEffect(() => {
    let schoolId = JSON.parse(localStorage.getItem("schoolId"));
    if (schoolId) {
      GetTheCurrentSchoolStartDate(schoolId);
    }
  }, []);

  const GetTheCurrentSchoolStartDate = async (schoolId) => {
    let schoolRef = doc(db, "Schools", schoolId);
    let schoolDoc = await getDoc(schoolRef);
    let schoolStartMonth = new Date(
      schoolDoc.data().SchoolStartDate
    ).getMonth();
    let schoolStartYear = new Date(
      schoolDoc.data().SchoolStartDate
    ).getFullYear();

    let TotalYears = schoolStartYear - new Date().getFullYear();
    let TotalMonths = schoolStartMonth - new Date().getMonth();
    TotalMonths = TotalYears * 12 + TotalMonths;
    let startDate, endDate, UserType;

    // getUsersCountByMonth(startDate, endDate, schoolId, UserType);
  };

  const getUsersCountByMonth = async (
    startDate,
    endDate,
    schoolId,
    UserType
  ) => {
    const UsersRef = collection(db, "Users");
    const q = query(
      UsersRef,
      where("signupDate", ">=", startDate),
      where("signupDate", "<", endDate),
      where("SchoolID", "==", schoolId),
      where("UserType", "==", UserType)
    );

    const docs = await getDocs(q);
    console.log(docs.size);
  };

  return {
    ChartData,
    VerticalChart,
    TotalNoOFStudents,
    TotalNoOFTeachers,
    TotalNoOFClasses,
  };
};

export default DashBoardViewModal;
